import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';

type SubscriberType = string | null;

// Define the context type
interface SubscriberContextType {
  subscriber: SubscriberType;
  setSubscriber: Dispatch<SetStateAction<SubscriberType>>;
}

export const SubscriberContext = createContext<SubscriberContextType | undefined>(undefined);

interface SubscriberProviderProps {
  children: ReactNode;
}
export const SubscriberProvider = ({ children }: SubscriberProviderProps) => {
  const [subscriber, setSubscriber] = useState<SubscriberType>(null);
  const contextValue = useMemo(() => ({ subscriber, setSubscriber }), [subscriber]);

  return <SubscriberContext.Provider value={contextValue}>{children}</SubscriberContext.Provider>;
};

export function useSubscriber() {
  const context = useContext(SubscriberContext);
  if (!context) {
    throw new Error('useSubscriber must be used within a SubscriberProvider');
  }
  return context;
}
